import axios from 'axios';
import React from 'react';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchUserList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getUserList',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.get(serviceURL, payload);
};

export default apiFetchUserList;
